import type { ReactiveMap } from "@solid-primitives/map"
import type { NeighborElevationCollection } from "../../../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap"
import type { TileGraphNode } from "../../../../core/engine/TileGraphNode/TileGraphNode.type"
import type { EntityId } from "../../../../core/entity/EntityId.type"
import type { EntityTypeId } from "../../../../core/entity/EntityTypeId.enum"
import isEntityWithGrassWaves from "./isEntityWithGrassWaves"

export type CreateTileGraphNodeGrassWavesGeometryV1DataInputItem = {
  x: TileGraphNode['x']
  y: TileGraphNode['y']
  index: TileGraphNode['index']
  etype_id: EntityTypeId
  ent_id: EntityId
  bec: NeighborElevationCollection
}

export default function createTileGraphNodeGrassWavesGeometryV1WorkerInput(
  nodeList: Array<TileGraphNode>,
  neighborBaseElevationReactiveMap: ReactiveMap<number, NeighborElevationCollection>,
): Array<CreateTileGraphNodeGrassWavesGeometryV1DataInputItem> {
  const inputData: Array<CreateTileGraphNodeGrassWavesGeometryV1DataInputItem> = []
  nodeList.forEach(node => {
    const grassEnt = node.ents().find(isEntityWithGrassWaves)
    const baseElevationCollection = neighborBaseElevationReactiveMap.get(node.index)
    if (grassEnt && baseElevationCollection) {
      inputData.push({
        x: node.x,
        y: node.y,
        index: node.index,
        etype_id: grassEnt.etype_id,
        ent_id: grassEnt.id,
        bec: baseElevationCollection,
      })
    }
  })

  return inputData
}
